/* eslint-disable import/no-anonymous-default-export */
import axios from "axios";
import { API_ENDPOINTS } from "../../Constants";

const toMultipartFormData = (data = {}) => {
  const formData = new FormData();

  Object.entries(data).forEach(([key, value]) => {
    if (value === undefined || value === null) {
      return;
    }

    // Only send file-like payloads for image fields; skip existing URL strings.
    if (key === "image" && !(value instanceof Blob)) {
      return;
    }

    formData.append(key, value);
  });

  return formData;
};

// eslint-disable-next-line import/no-anonymous-default-export
export default {
  getPassengersList: (params) => {
    return axios.get(API_ENDPOINTS.GET_CUSTOMERS_LIST, {
      headers: { isAuthRequired: true, "Content-Type": "application/json" ,"x-tenant-slug":"default"},
      params,
    });
  },
  getPassengerDetails: (id) => {
    return axios.get(API_ENDPOINTS.GET_CUSTOMER_DETAILS_BY_ID + "/" + id, {
      headers: { isAuthRequired: true, "Content-Type": "application/json","x-tenant-slug":"default" },
    });
  },
  addPassengers: (data) => {
    const formData = data instanceof FormData ? data : toMultipartFormData(data);
    return axios.post(API_ENDPOINTS.ADD_PASSENGERS, formData, {
      headers: { isAuthRequired: true, "x-tenant-slug":"default" },
    });
  },
  updatePassengers: (id, data) => {
    let url = API_ENDPOINTS.UPDATE_CUSTOMER_DETAILS_BY_ID + "/" + id;
    const formData = data instanceof FormData ? data : toMultipartFormData(data);
    return axios.put(url, formData, {
      headers: { isAuthRequired: true, "x-tenant-slug":"default" },
    });
  },
  deletePassenger: (id) => {
    return axios.delete(API_ENDPOINTS.DELETE_CUSTOMER_DETAILS_BY_ID + "/" + id, {
      headers: { isAuthRequired: true, "Content-Type": "application/json","x-tenant-slug":"default" },
    });
  },
  deletedriver: (data) => {
  return axios.delete(API_ENDPOINTS.DELETE_DRIVER, {
    headers: { isAuthRequired: true, "Content-Type": "application/json","x-tenant-slug":"default" },
    data
  });
  },
  getPassengerDashboard: (params = {}) => {
    return axios.get(API_ENDPOINTS.GET_PASSENGER_DASHBOARD, {
      headers: {
        isAuthRequired: true,
        "Content-Type": "application/json",
        "x-tenant-slug": "default",
      },
      params,
    });
  },
  getPassengerrequesthistory: (params) => {
    return axios.get(API_ENDPOINTS.GET_PASSENGER_REQUEST_HISTORY + "/" + params.passenger_id, {
      headers: { isAuthRequired: true, "Content-Type": "application/json","x-tenant-slug":"default" },
      params
    });
  },
  getPassengerRides: (params) => {
    return axios.get(API_ENDPOINTS.GET_PASSENGER_RIDES, {
      headers: { isAuthRequired: true, "Content-Type": "application/json", "x-tenant-slug": "default" },
      params,
    });
  },
  getPassengerRidesList: (params) => {
    return axios.get(API_ENDPOINTS.GET_PASSENGER_RIDES_LIST, {
      headers: { isAuthRequired: true, "Content-Type": "application/json", "x-tenant-slug": "default" },
      params,
    });
  },
  getLikedBookings: (params) => {
    return axios.get(API_ENDPOINTS.GET_PASSENGER_LIKED, {
      headers: { isAuthRequired: true, "Content-Type": "application/json", "x-tenant-slug": "default" },
      params,
    });
  },
  getPassengerrequesthistorybyid: (id) => {
    return axios.get(API_ENDPOINTS.GET_PASSENGER_REQUEST_HISTORY_BYID + "/" + id, {
      headers: { isAuthRequired: true, "Content-Type": "application/json","x-tenant-slug":"default" }
    });
  },
  getPassengertriphistorybyid: (id) => {
    return axios.get(API_ENDPOINTS.GET_PASSENGER_TRIP_HISTORY_BYID + "/" + id, {
      headers: { isAuthRequired: true, "Content-Type": "application/json" ,"x-tenant-slug":"default"}
    });
  },
  deletePassengerrequesthistorybyid: (id) => {
    return axios.delete(API_ENDPOINTS.DELETE_PASSENGER_REQUEST_BYID + "/" + id, {
      headers: { isAuthRequired: true, "Content-Type": "application/json","x-tenant-slug":"default" }
    });
  },
};
